import { getAuthServiceInstance } from "./auth";

export default function authHeader(navigate: any) {
    const accessToken = getAuthServiceInstance(navigate).getAccessToken();
    if (accessToken === null) {
        navigate('/app/login', { replace: true });
    }

    return { Authorization: 'Bearer ' + accessToken };
}